import axios from 'axios';
import { CONSTANTS } from '../common/constants';
// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs
const axiosInstance = axios.create({
    baseURL: CONSTANTS.BASE_API,
    // paramsSerializer: (params) => queryString.stringify(params),
});

axiosInstance.interceptors.request.use(async (config) => {
    const token = localStorage.getItem(CONSTANTS.LOGIN_TOKEN);
    const language = localStorage.getItem(CONSTANTS.LANGUAGE) || 'VI';
    if (token) {
        config.headers = {
            Authorization: `Bearer ${token}`,
            language
        };
    }
    return config;
});

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // eslint-disable-next-line no-console
        if (error.response && error.response.status === 401) {
            // actionRefreshToken();
            // Xử lí refreshtoken tại đây nếu bị lỗi 401
            localStorage.removeItem(CONSTANTS.SECRET_TOKEN);
            localStorage.removeItem(CONSTANTS.LOGIN_TOKEN);
            localStorage.removeItem(CONSTANTS.LOGIN_DATA);
            window.location.href = "/trang-chu";
        } else {
            return Promise.reject(error);
        }
    },
);

export default axiosInstance;